<template>
    <div
        class="d-flex"
        style="z-index: 950"
    >
        <div style="width: 2em; height: 2.5em"></div>
        <div>
            <span
                class="p-3 text-white display-6 fw-light"
                style="background-color: #111111dd; border: 1px solid #000; position: relative; top: 2.8em; left: -2px; z-index: 950"
                >{{ label }}</span
            >
        </div>
    </div>
</template>
<script lang="ts" setup>
import { TooltipComp } from '@/components';

const props = defineProps<{
    label: string;
}>();
</script>
